export const FormStepConstants = {
    POST_SEND_FORM_REQUEST: 'POST_SEND_FORM_RQUEST',
    POST_SEND_FORM_SUCCESS: 'POST_SEND_FORM_SUCCESS',
    POST_SEND_FORM_ERROR: 'POST_SEND_FORM_ERROR',

    GET_SEND_FORM_RQUEST: 'GET_SEND_FORM_REQUEST',
    GET_SEND_FORM_SUCCESS: 'GET_SEND_FORM_SUCCESS',
    GET_SEND_FORM_ERROR: 'GET_SEND_FORM_ERROR'
}